<div class="data-card">
  <div class="data-card-header">
    <div class="data-card-title-section">
      <div class="data-card-platform-logo">
        @if (card.platformLogoPath) {
          <img [src]="card.platformLogoPath" alt="Platform Logo" />
        }
      </div>
      <div class="data-card-title-and-id">
        <div class="data-card-title-row">
          <div class="data-card-primary-title" appLongTextTooltip>
            {{ card.primaryCardTitle }}
          </div>
          @if (card.statusLabel) {
            <span
              class="data-card-status-dot"
              [ngClass]="'status-' + card.statusLabel"
              [title]="card.statusTooltip || ''"
            ></span>
          }
        </div>
        <div class="data-card-id-and-scan">
          <span class="id-label">ID:</span>
          @if (card.cardId) {
            <app-copy-button
              [value]="card.cardId"
              [withCopyIcon]="true"
              [fixedSize]="true"
              class="id-copy-button"
            ></app-copy-button>
          }
          @if (card.cardType === 'integration' && card.secondaryCardValue) {
            <span class="id-scan-divider"></span>
            <span class="last-scan-label">{{ card.secondaryCardTitle }}:</span>
            <span class="last-scan-value">{{ card.secondaryCardValue }}</span>
            @if (card.secondaryCardTooltipText) {
              <img
                src="assets/images/common/info.svg"
                alt="info"
                class="last-scan-info"
                [title]="card.secondaryCardTooltipText"
              />
            }
          }
        </div>
      </div>
    </div>
    <div class="data-card-action-menu">
      @if (card.menuActions && card.menuActions.length > 0) {
        <app-actions-menu-icon [actions]="card.menuActions" (actionOnClick)="actionOnClick($event)" [smallSize]="true">
        </app-actions-menu-icon>
      }
    </div>
  </div>

  <div class="data-card-content">
    <div class="left-column">
      <app-card-fields [cardFields]="card.leftCardFields" [verticalOrder]="true"></app-card-fields>
    </div>
    <div class="right-column">
      <app-card-fields [cardFields]="card.rightCardFields" [verticalOrder]="true"></app-card-fields>
    </div>
  </div>
</div>
